import * as React from 'react';

var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgVisa24 = function SvgVisa24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 40,
    height: 24,
    rx: 2,
    fill: "#1434CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.112 16.262-3.142 7.496h-2.05l-1.546-5.982c-.094-.369-.176-.503-.462-.659-.466-.253-1.235-.49-1.912-.637l.046-.218h3.3c.42 0 .799.28.894.764l.817 4.338 2.018-5.103h2.038-.001Zm8.032 5.049c.008-1.979-2.736-2.088-2.717-2.972.006-.269.262-.555.823-.628.277-.036 1.043-.064 1.912.336l.34-1.59a5.21 5.21 0 0 0-1.813-.332c-1.917 0-3.266 1.018-3.278 2.478-.012 1.079.963 1.681 1.698 2.04.756.367 1.01.603 1.007.931-.006.503-.603.725-1.162.734-.975.015-1.54-.264-1.99-.473l-.352 1.642c.453.208 1.29.39 2.156.398 2.038 0 3.37-1.006 3.377-2.564h-.001Zm5.062 2.447H32l-1.567-7.496h-1.655a.882.882 0 0 0-.825.55l-2.91 6.946h2.037l.404-1.12h2.488l.234 1.12Zm-2.163-2.656 1.02-2.815.588 2.815h-1.608Zm-8.16-4.84-1.604 7.496h-1.94l1.605-7.496h1.939Z",
    fill: "#fff"
  })));
};

var Visa24Svg = SvgVisa24;

export { Visa24Svg as default };
//# sourceMappingURL=Visa24.svg.js.map
